// @flow
import { connect } from 'react-redux'
import StatisticMetricsPage from './StatisticMetricsPage'
import _ from 'lodash'
import * as reducer from '../redux/ducks/statisticMetricsPage/reducers'
import type { State } from '../redux/ducks/statisticMetricsPage/reducers'
import type { Store } from '../redux/ducks'
import store from '../redux/store'
import getJson from '../services/getJson'
import postJson from '../services/postJson'
import type { Counter } from './StatisticMetricsPage'

const COUNTERS_UPDATE_URL = '/statistic_metrics/update_counters'
const STATISTIC_METRIC_CREATE_URL = '/statistic_metrics'

const t = {
  success: 'Выбор целей успешно сохранён'
}

type GoalData = {|
  id: string,
  name: string
|}

type CounterData = {|
  id: string,
  provider: string,
  data_type: 'goals' | 'transactions',
  goals: Array<GoalData>
|}

function mapStateToProps(state: Store, ownProps) {
  return {
    ...ownProps,
    ...state.statisticMetricsPage
  }
}

function mapDispatchToProps(dispatch: Function) {
  return {
    onInit: (initial: State) => {
      dispatch(reducer.init(initial))
    },
    onChange: (diff: $Shape<State>) => {
      dispatch(reducer.patch(diff))
    },
    onCountersUpdate: (provider: string) => {
      dispatch(reducer.patch({ isLoading: true }))
      getJson(COUNTERS_UPDATE_URL, { provider: provider })
        .done((response) => {
          const state = store.getState()
          const compState = state.statisticMetricsPage
          const newCounters = [
            ..._.reject(compState.allCounters, (counter) => {
              return _.isEqual(counter.provider, provider)
            }),
            ...response.counters
          ]
          dispatch(
            reducer.patch({
              allCounters: newCounters,
              selectedYandexGoalIds: [],
              selectedGAGoalIds: []
            })
          )
        })
        .fail(() => window.alert('Internal error'))
        .always(() => dispatch(reducer.patch({ isLoading: false })))
    },
    onApply: () => {
      dispatch(reducer.patch({ isLoading: true }))
      const state = store.getState()
      const {
        allCounters,
        selectedYandexCounterId,
        selectedGACounterIds,
        selectedYandexGoalIds,
        selectedGAGoalIds,
        gaDataType
      } = state.statisticMetricsPage

      const countersData = [
        ...counters(
          allCounters,
          [selectedYandexCounterId],
          selectedYandexGoalIds,
          'metrica',
          'goals'
        ),
        ...counters(
          allCounters,
          selectedGACounterIds,
          selectedGAGoalIds,
          'google_analytics',
          gaDataType
        )
      ]
      postJson(STATISTIC_METRIC_CREATE_URL, { counters: countersData })
        .done(() => {
          window.alert(t.success)
        })
        .fail(() => window.alert('Internal error'))
        .always(() => dispatch(reducer.patch({ isLoading: false })))
    }
  }
}

function counters(
  allCounters: Array<Counter>,
  counterIds: Array<string>,
  goalIds: Array<string>,
  provider: string,
  dataType: 'goals' | 'transactions'
): Array<CounterData> {
  if (_.isEmpty(goalIds) && _.every(counterIds, _.isEmpty)) return []

  return _.compact(
    _.map(counterIds, (counterId) => {
      const selectedCounter = _.find(allCounters, (counter) => {
        return _.isEqual(counter.id, counterId) && _.isEqual(counter.provider, provider)
      })
      if (!selectedCounter) return null

      let goals = []
      if (_.isEmpty(goalIds) && _.isEqual(dataType, 'goals')) {
        goals = selectedCounter.goals
      } else if (_.isEqual(dataType, 'goals')) {
        goals = _.filter(selectedCounter.goals, (goal) => {
          return _.includes(goalIds, `${counterId}_${goal.id}`)
        })
      }

      return {
        id: counterId,
        provider: provider,
        data_type: dataType,
        goals: goals
      }
    })
  )
}

const StatisticMetricsPageContainer = connect<Object, Object, _, _, _, _>(
  mapStateToProps,
  mapDispatchToProps
)(StatisticMetricsPage)

export default StatisticMetricsPageContainer
